<template>
  <Loading
    :contentSize="true"
    :state="( ( !attrs || !data ) && !error ) || loading"
    class="mainLoading"
  >
    <div v-if="attrs" class="mainWrapper">
      <div v-if="data && !error" class="mainTitle" style="margin-bottom: 0.5em">
        <Icon
          symbol="back"
          class="back"
          title="к предыдущему элементу"
          @click.native="$router.go( -1 )"
        />

        {{ $t( "ObjectView" ) }} «<span>{{ name }}</span>», URI: <span>{{ id }}</span>
      </div>
      <Tabs
        class="tabs"
        :class="tabCurrent ? tabCurrent : ''"
        :activeId="tabActiveId"

        @active="tabCurrent = $event.data ? $event.data.id : null"
      >
        <Tab
          id="tabObject"
          :name="$t( 'ObjectTab' )"
          icon="object"
          @active=""
        >
          <div v-if="data && !error">
            <ObjectEditor
              class="objectEditor"

              :endpoint="endpoint"
              :id="id"
              :classId="classId"
              :item="data"
              :attrs="attrs"
              :historyButtons="true"
              :requestOnSave="false"

              :canCreate="permitted( 'objCrt', endpoint )"
              :canUpdate="permitted( 'objUpd', endpoint )"
              :canDelete="permitted( 'objDel', endpoint )"

              @history="historyAttrRq( $event )"
              @input="$event.operation == 'delete' ? $emit( 'refresh' ) : refreshAll()"
              @close="close()"
            />
          </div>
          <div class="empty" v-else-if="error">
            <div class="mainTitle">{{ $t( "ObjectView" ) }} «<span>{{ name }}</span>»</div>
            {{ error }}
          </div>
        </Tab>

        <Tab
          id="tabHistory"
          :name="$t( 'HistoryTab' )"
          icon="history"
          @active="$event.state && !history && historyRq()"
        >
          <Loading
            class="history"
            :hideInside="history === undefined"
            :state="history === undefined"
          >
            <table v-if="history && history.length" border="0" cellspacing="0" cellpadding="0" class="items">
              <caption></caption>
              <tr v-for="item in history" :key="item.id">
                <td>
                  <table border="0" cellspacing="0" cellpadding="0" class="item attrs">
                    <caption></caption>
                    <tr>
                      <th scope="row">{{ $t( "Date" ) }}</th>
                      <td>{{ $options.dates.format( item.date, $options.dates.types.ISO, dateType, true, true, false ) }}</td>
                    </tr>
                    <tr>
                      <th scope="row">{{ $t( "User" ) }}</th>
                      <td>{{ item.user ? item.user : "" }}</td>
                    </tr>
                    <tr>
                      <th scope="row">{{ $t( "Type" ) }}</th>
                      <td v-if="item.type == 'insert'">{{ $t( "Creating" ) }}</td>
                      <td v-else-if="item.type == 'update'">{{ $t( "Updating" ) }}</td>
                      <td v-else-if="item.type == 'delete'">{{ $t( "Deleting" ) }}</td>
                      <td v-else>{{ item.type }}</td>
                    </tr>
                    <tr>
                      <th scope="row">{{ $t( "Attributes" ) }}</th>
                      <td class="attrsWrapper">
                        <table border="0" cellspacing="0" cellpadding="0" class="attrs">
                          <caption></caption>
                          <tr v-for="a in item.attrs" :key="a.id">
                            <th scope="row">{{ a.name }}</th>
                            <td>
                              <table border="0" cellspacing="0" cellpadding="0">
                              <caption></caption>
                              <template v-if="referenceIs( a )">
                                <tr v-for="v in a.values" :key="v.id" class="values"><td>
                                  <router-link :to="viewLink( v.id )">{{ valueByAttr( v, a.id ) }}</router-link>
                                </td></tr>
                              </template>
                              <template v-else>
                                <tr v-for="( values, l ) in a.values" :key="l" class="values"><td>
                                  <div v-for="( v, i ) in values" :key="i">{{ valueByAttr( v, a.id ) }} <span v-if="l" class="lang">{{ $t( "language" ) + " " + $langBrief( l ) }}</span></div>
                                </td></tr>
                              </template>
                              </table>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
            <div v-else class="empty">{{ $t( "HistoryEmpty" ) }}</div>
          </Loading>
        </Tab>

        <Tab
          id="tabProvenance"
          :name="$t( 'ProvenanceTab' )"
          icon="provenance"
          @active="$event.state && !derivations && derivationsRq()"
        >
          <Loading
            class="provenance"
            :hideInside="derivations === undefined"
            :state="derivations === undefined"
          >
            <table v-if="derivations && derivations.itemsByValues.length" border="0" cellspacing="0" cellpadding="0" class="attrs">
              <caption></caption>
              <tr
                v-for="item in derivations.itemsByValues"
                :key="item.derivation.id + '_' + item.affectedAttrId"
              >
                <th scope="row">{{ attrs[ item.affectedAttrId ] ? attrs[ item.affectedAttrId ].name : item.affectedAttrId }}</th>
                <td>
                  <template v-if="data.attrs[ item.affectedAttrId ]">
                    <template v-if="attrs[ item.affectedAttrId ] && attrs[ item.affectedAttrId ].type == 'reference'">
                      <router-link
                        :class="i > 0 ? 'comma' : ''"
                        v-for="( v, i ) in data.attrs[ item.affectedAttrId ].values"
                        :key="v.id"
                        :title="nameOrId( v, true )"

                        :to="viewLink( v.id )"
                      >{{ nameOrId( v ) }}</router-link>
                    </template>
                    <template v-else>
                      {{ data.attrs[ item.affectedAttrId ].values.reduce( ( a, i ) => { if ( "value" in i ) a += ( a ? ", " : "" ) + i.value; return a; }, "" ) }}
                    </template>
                  </template>
                </td>
                <td>
                  <template
                    v-for="o in item.derivation.attrs['http://www.w3.org/ns/prov#wasInfluencedBy'].values"
                  >
                    <router-link
                      :title="nameOrId( o, true )"

                      :to="viewLink( o.id )"
                      v-if="
                        item.derivation.attrs['http://www.w3.org/ns/prov#wasInfluencedBy'] &&
                        ( 'values' in item.derivation.attrs['http://www.w3.org/ns/prov#wasInfluencedBy'] ) &&
                        item.derivation.attrs['http://www.w3.org/ns/prov#wasInfluencedBy'].values.length
                      "

                      :key="o.id"
                    >{{ nameOrId( o ) }}</router-link>

                    <span class="links">
                    <router-link
                      class="linkMisc"
                      v-for="( cn, cid ) in derivations.classesById[ o.id ]"
                      :title="cn + ' (' + cid + ')'"

                      :to="viewLink( cid )"

                      :key="o.id + '_' + cid"
                    >{{ cn }}</router-link>
                    </span>
                  </template>
                    <!-- <span class="shorten">(<span>{{ o.id }}</span>)</span> -->
                    <!-- (<span v-if="o.id in derivations.classesById">{{ classesByIdText( o.id ) }}</span>) -->
                </td>
                <td>
                  <template
                    v-for="( o, i ) in item.derivation.attrs['http://www.w3.org/ns/prov#wasInfluencedBy'].values"
                  >
                    <router-link
                      v-if="derivations.originsById[ o.id ]"
                      :class="i > 0 ? 'comma' : ''"
                      :title="nameOrId( derivations.originsById[ o.id ], true )"

                      :to="viewLink( derivations.originsById[ o.id ].id )"
                    >{{ nameOrId( derivations.originsById[ o.id ] ) }}</router-link>
                  </template>
                </td>
              </tr>
            </table>
            <div v-else class="empty">{{ $t( "ProvenanceEmpty" ) }}</div>
          </Loading>
        </Tab>

        <Tab
          id="tabReference"
          :name="$t( 'ReferenceTab' )"
          icon="reference"
          @active="$event.state && !duplicates && duplicatesRq()"

          v-slot="tabData"
        >
          <!-- to hide this tab: v-if="'http://www.w3.org/2002/07/owl#sameAs' in data.attrs" -->

          <Loading
            :hideInside="duplicates === undefined"
            :state="duplicates === undefined"
          >
            <div
              class="referenceObject"
              v-if="'http://datavera.kz/ekg/hasReferenceObject' in data.attrs"
            >
              {{ $t( "ReferenceObject" ) + ":" }}
              <router-link
                :title="nameOrId( data.attrs['http://datavera.kz/ekg/hasReferenceObject'].values[0], true )"

                :to="viewLink( data.attrs['http://datavera.kz/ekg/hasReferenceObject'].values[0].id )"
              >{{ nameOrId( data.attrs["http://datavera.kz/ekg/hasReferenceObject"].values[0] ) }}</router-link>
            </div>

            <table v-if="duplicates" border="0" cellspacing="0" cellpadding="0" class="duplicates attrs">
              <caption>{{ $t( "Duplicates" ) }}</caption>
              <tr>
                <th scope="col">{{ $t( "Object" ) }}</th>
                <th scope="col">{{ $t( "Source" ) }}</th>
                <th scope="col">{{ $t( "SourceCode" ) }}</th>
              </tr>
              <tr v-for="o in duplicates">
                <td>
                  <router-link
                    :title="nameOrId( o, true )"

                    :to="viewLink( o.id )"
                  >{{ nameOrId( o ) }}</router-link>
                </td>
                <td>
                  <router-link
                    v-if="o.origin"
                    :title="nameOrId( o.origin, true )"

                    :to="viewLink( o.origin.id )"
                  >{{ nameOrId( o.origin ) }}</router-link>
                </td>
                <td>
                  {{ o.originCode === null ? "" : o.originCode }}
                </td>
              </tr>
            </table>
            <div v-else class="duplicates">{{ $t("DuplicatesNotFound") }}</div>

            <table v-if="consolidateErrors" border="0" cellspacing="0" cellpadding="0" class="attrs" style="margin-bottom: 0.5em;">
              <caption>{{ $t( "ConsolidateErrors" ) }}</caption>
              <tr>
                <th scope="col">{{ $t( "Description" ) }}</th>
                <th scope="col">{{ $t( "Type" ) }}</th>
                <th scope="col">{{ $t( "Date" ) }}</th>
                <th scope="col">{{ $t( "Properties" ) }}</th>
              </tr>
              <tr v-for="o in consolidateErrors">
                <td>
                  <router-link
                    :title="o.description ? o.description : o.id"

                    :to="viewLink( o.id )"
                  >{{ o.description ? o.description : o.id }}</router-link>
                </td>
                <td>
                  <div
                    v-for="( tN, tId ) in o.type"
                    :key="tId"
                  >
                    {{ tN ? tN : tId }}
                  </div>
                </td>
                <td>
                  {{ $options.dates.format( o.time, $options.dates.types.ISO, dateType, true, true ) }}
                </td>
                <td>
                  <div
                    v-for="( tN, tId ) in o.properties"
                    :key="tId"
                  >
                    {{ tN ? tN : tId }}
                  </div>
                </td>
              </tr>
            </table>

            <Button
              class="consolidate"
              @click="consolidate()"
            >{{ $t("Consolidate" ) }}</Button>
          </Loading>
        </Tab>

        <Tab
          id="tabLinked"
          :name="$t( 'LinkedTab' )"
          icon="linked"
          @active="$event.state && !linked && linkedRq()"

          v-slot="tabData"
        >
          <Loading
            :hideInside="linked === undefined"
            :state="linked === undefined"
          >
            <template v-if="linked && ( linked.to !== null || linked.from !== null )">
              <template v-if="linked.to !== null">
                <div class="linkedHdr">{{ $t( "linkedToHdr" ) }}</div>
                <div
                  class="linkedClass"
                  v-for="( cls, cid ) in linked.to"
                >
                  <!--
                  <router-link
                    :title="cls.name ? cls.name : cid"

                    :to="viewLink( cid )"
                  >{{ cls.name ? cls.name : cid }}</router-link>
                  -->
                  {{ cls.name ? cls.name : cid }}
                  <div
                    class="linkedClassItems"
                    v-for="( tN, tId ) in cls.items"
                  >
                    <router-link
                      :title="tN ? tN : tId"

                      :to="viewLink( tId )"
                    >{{ tN ? tN : tId }}</router-link>
                  </div>
                </div>
              </template>

              <template v-if="linked.from !== null">
                <div class="linkedHdr">{{ $t( "linkedFromHdr" ) }}</div>
                <div
                  class="linkedClass"
                  v-for="( cls, cid ) in linked.from"
                >
                  <!--
                  <router-link
                    :title="cls.name ? cls.name : cid"

                    :to="viewLink( cid )"
                  >{{ cls.name ? cls.name : cid }}</router-link>
                  -->
                  {{ cls.name ? cls.name : cid }}
                  <div
                    class="linkedClassItems"
                    v-for="( tN, tId ) in cls.items"
                  >
                    <router-link
                      :title="tN ? tN : tId"

                      :to="viewLink( tId )"
                    >{{ tN ? tN : tId }}</router-link>
                  </div>
                </div>
              </template>
            </template>
            <div v-else class="linked">{{ $t("linkedNotFound") }}</div>
          </Loading>
        </Tab>

        <Tab
          id="tabGraph"
          :name="$t( 'GraphTab' )"
          icon="graph"
          @active=""

          v-slot="tabData"
        >
          <ObjectViewGraphView
            :id="id"
            :endpoint="endpoint"
          />
        </Tab>
      </Tabs>
    </div>

    <Modal
      :show="historyAttr && historyAttr.show"
      :emptyBodyUse="true"
      :title="historyAttr ? this.$t( 'AttributeHistoryView' ) + ' «' + historyAttr.name + '»' : ''"
      :acceptButtonText="this.$t( 'Ok' )"
      cancelButtonText=""

      @close="historyAttr.show = false"
      @accept="historyAttr.show = false"
    >
      <Loading
        :contentSize="true"
        :state="!historyAttr || historyAttr.items === null"
        :hideInside="!historyAttr || historyAttr.items === null"
      >
        <table v-if="historyAttr && historyAttr.items && historyAttr.items.length" border="0" cellspacing="0" cellpadding="0" class="historyAttr attrs">
          <caption></caption>
          <tr>
            <th scope="row">{{ $t( "date" ) }}</th>
            <th scope="row">{{ $t( "operation" ) }}</th>
            <th scope="row">{{ $t( "values" ) }}</th>
            <th scope="row">{{ $t( "user" ) }}</th>
          </tr>
          <tr v-for="( item, i ) in historyAttr.items" :key="i">
            <td>{{ $options.dates.format( item.date, $options.dates.types.ISO, dateType, true, true, false ) }}</td>
            <td v-if="item.type == 'insert'">{{ $t( "Creating" ) }}</td>
            <td v-else-if="item.type == 'update'">{{ $t( "Updating" ) }}</td>
            <td v-else-if="item.type == 'delete'">{{ $t( "Deleting" ) }}</td>
            <td v-else>{{ item.type }}</td>
            <td class="attrsWrapper">
              <table border="0" cellspacing="0" cellpadding="0" class="values">
                <caption></caption>
                <tr><td>
                  <table v-if="referenceIs( historyAttr )" border="0" cellspacing="0" cellpadding="0">
                    <caption></caption>
                    <tr v-for="v in item.values" :key="v.id">
                      <td>
                        <router-link :to="viewLink( v.id )">{{ valueByAttr( v, historyAttr.id ) }}</router-link>
                      </td>
                    </tr>
                  </table>
                  <table v-else border="0" cellspacing="0" cellpadding="0">
                    <caption></caption>
                    <tr v-for="( values, l ) in item.values" :key="l">
                      <th scope="col" v-if="l">{{ $t( "language" ) + " " + $langBrief( l ) }}</th>
                      <th scope="col" v-else></th>
                      <td><div v-for="( v, i ) in values" :key="v + i">{{ v }}</div></td>
                    </tr>
                  </table>
                </td></tr>
              </table>
            </td>
            <td>{{ item.user ? item.user : "" }}</td>
          </tr>
        </table>
        <div v-else class="empty">{{ $t( "HistoryEmpty" ) }}</div>
      </Loading>
    </Modal>
<!--
    <Modal
      :show="$route.name === 'objectViewGraphView'"
      :emptyBodyUse="true"
      :acceptButtonText="$t( 'Ok' )"
      :cancelButtonText="''"
      class="graphViewModal"

      @close="childrenClose()"
      @accept="childrenClose()"
    >
      <router-view name="objectViewGraphView" />
    </Modal>
-->
  </Loading>
</template>

<script>
  import utils from "@/utils";
  import dates from "@/dates";
  import fbu from "../frontbackUtils.js";

  import Loading from "@/components/Loading";
  import Tabs from "@/components/Tabs/Tabs";
  import Tab from "@/components/Tabs/Tab";
  import Icon from "@/components/Icon";
  import Modal from "@/components/Modal";
  import Tooltip from "@/components/Tooltip";
  import Slide from "@/components/SlideUpDown";
  import Button from "@/components/Button";
  import ObjectViewGraphView from "./ObjectViewGraphView";
  import DVfield from "./DVfield";


  import ObjectEditor from "./ObjectEditor";

  export default {
		name:  "ObjectView",

    components: {
      DVfield,
      ObjectViewGraphView,
		  Loading,
      Tabs,
      Tab,
      Icon,
      Modal,
      Tooltip,
      Slide,
      Button,

      ObjectEditor
    },

    utils,

    i18n: {
      messages: {
        ru: {
          ReferenceTab:                   "Эталон",
          ObjectTab:                      "Общая информация",
          HistoryTab:                     "История изменений",
          ProvenanceTab:                  "Происхождение",
          GraphTab:                       "Граф связей",
          ObjectView:                     "Просмотр объекта",
          AttributeHistoryRequest:        "Запросить историю изменений атрибута",
          HistoryEmpty:                   "История отсутствует",
          AttributeHistoryView:           "Просмотр истории атрибута",
          Operation:                      "Операция",
          ObjectClassesNotFound:          "Не найдены классы объекта",
          InvalidConstraintsRequestAnswer:"Ошибка формата ответа запроса логической целостности",
          ConstraintsDataError:           "Не возможно получить данные логической целостности",
          ObjectNoClassesOrProps:         "Объект не имеет схемы классов или свойств.",
          InvalidClassesSchemaAnswer:     "Ошибка формата ответа запроса схемы класса(в)",
          InvalidObjectRequestAnswer:     "Ошибка формата ответа запроса объекта",
          ProvenanceRequest:              "Запросить информацию о происхождении",
          ProvenanceEmpty:                "Информация о происхождении отсутствует",
          ReferenceObject:                "Эталонный объект",
          Duplicates:                     "Дубликаты",
          DuplicatesNotFound:             "Дубликаты не найдены.",
          Source:                         "Источник",
          SourceCode:                     "Код в источнике",
          Consolidate:                    "Консолидировать",
          Consolidation:                  "Консолидация",
          ConsolidatedSuccessfully:       "Консолидация прошла успешно",
          ValueRemove:                    "Убрать значение",
          ValueAdd:                       "Добавить еще значение",
          RefCantEmpty:                   "Указатель не может быть пустым",
          RefFillOrRemove:                "Заполните его, или удалите поле с ним",
          ConsolidateErrors:              "Ошибки консолидации",
          linkedToHdr:                    "Входящие ссылки (на объект):",
          linkedFromHdr:                  "Исходящие ссылки (из объекта):",
          LinkedTab:                      "Связанные объекты",
          linkedNotFound:                 "Связанные объекты отсутствуют",
        },

        en: {
          ReferenceTab:                   "Reference",
          ObjectTab:                      "General info",
          HistoryTab:                     "Changes history",
          ProvenanceTab:                  "Provenance",
          GraphTab:                       "Graph",
          ObjectView:                     "Label:",
          AttributeHistoryRequest:        "Attribute history of changes request",
          HistoryEmpty:                   "No history",
          AttributeHistoryView:           "Attribute history view",
          Operation:                      "Operation",
          ObjectClassesNotFound:          "no object's classes",
          InvalidConstraintsRequestAnswer:"Invalid server's answer format for constraints rules request",
          ConstraintsDataError:           "Can't get constraints data",
          ObjectNoClassesOrProps:         "Object doesn't have classes or properties.",
          InvalidClassesSchemaAnswer:     "Invalid server's answer format for classes schema",
          InvalidObjectRequestAnswer:     "Invalid server's answer format for object",
          ProvenanceRequest:              "Provenance request",
          ProvenanceEmpty:                "No provenance info",
          ReferenceObject:                "Reference object",
          Duplicates:                     "Duplicates",
          DuplicatesNotFound:             "No duplicates found.",
          Source:                         "Source",
          SourceCode:                     "Data source ID",
          Consolidate:                    "Consolidate",
          Consolidation:                  "Consolidation",
          ConsolidatedSuccessfully:       "Consolidated successfully",
          ValueRemove:                    "Remove value",
          ValueAdd:                       "Add value",
          RefCantEmpty:                   "Reference can't be empty",
          RefFillOrRemove:                "Fill it or remove field with it",
          ConsolidateErrors:              "Consolidate errors",
          linkedToHdr:                    "Incoming relations (to the object):",
          linkedFromHdr:                  "Outgoing relations (from the object):",
          LinkedTab:                      "Related objects",
          linkedNotFound:                 "No related objects are found"
        },

        kz: {
          ReferenceTab:                   "Анықтама",
          ObjectTab:                      "Жалпы ақпарат",
          HistoryTab:                     "Тарихты өзгертеді",
          ProvenanceTab:                  "Туынды",
          GraphTab:                       "Сілтеме графигі",
          ObjectView:                     "Объектіні қарау",
          AttributeHistoryRequest:        "Сұрау төлсипатының өзгеру тарихы",
          HistoryEmpty:                   "Тарих жоқ",
          AttributeHistoryView:           "Төлсипат тарихын қарау",
          Operation:                      "Операциялық",
          ObjectClassesNotFound:          "нысан класстары табылмады",
          InvalidConstraintsRequestAnswer:"Логикалық тұтастық сұрауына жауап пішімінің қатесі",
          ConstraintsDataError:           "Логикалық тұтастық деректерін алу мүмкін емес",
          ObjectNoClassesOrProps:         "Нысанда сынып немесе сипат схемасы жоқ",
          InvalidClassesSchemaAnswer:     "Сыныптар диаграммасының сұрауына жауап пішімінің қатесі",
          InvalidObjectRequestAnswer:     "Нысан сұрауына жауап пішімі қатесі",
          ProvenanceRequest:              "Шығу туралы сұрау",
          ProvenanceEmpty:                "Шығу деректері жоқ",
          ReferenceObject:                "Анықтамалық объект",
          Duplicates:                     "Көшірмелер",
          DuplicatesNotFound:             "Көшірмелер табылмады.",
          Source:                         "Дереккөз",
          SourceCode:                     "Деректер көзі ID",
          Consolidate:                    "Біріктіру",
          Consolidation:                  "Біріктіру",
          ConsolidatedSuccessfully:       "Сәтті біріктірілді",
          ValueRemove:                    "Мәнді жою",
          ValueAdd:                       "Мән қосу",
          RefCantEmpty:                   "Көрсеткіш бос болуы мүмкін емес",
          RefFillOrRemove:                "Оны толтырыңыз немесе онымен өрісті жойыңыз",
          ConsolidateErrors:              "Қателерді біріктіру",
          linkedToHdr:                    "Кіріс қатысты объектілер (нысанға):",
          linkedFromHdr:                  "Шығыс байланысты объектілер (нысаннан):",
          LinkedTab:                      "Қатысты объектілер",
          linkedNotFound:                 "Ешқандай қатысты нысандар табылмады"
        }
      }
    },

    aType: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",

    props: {
      id: {
		    type: String,
        mandatory: true
      },

      endpoint: {
        type: String,
        mandatory: true
      },

      classId: {
        type: String,
        mandatory: false
      }
    },

    dates,
    hash: null,
    historyHash: null,

    data() {
		  return {
		    loading: false,

        tabCurrent: null,

		    attrs:null,
		    data: null,

        /*
        set of all possible attributes for the entity (from attrs),
        filled by entity's not inferred attributes values and classes (from data),
        classes specified by owl:Class attribute

        the structure is:
        {
          attrId: {
            values: [
              {...},
              ...
            ]
          }
        }
        */

        error: null,

        tabActiveId: "tabObject",

        historyShow: false,
        history: null,

        historyAttr: null,

        derivations: null,
        derivationsShow: false,

        duplicates: null,
        consolidateErrors: null,

        linked: null
      };
    },

    beforeRouteUpdate( to, from, next ) {
		  if ( to.params && to.params.id && this && !this.$checkAttrCanView( to.params.id ) ) {
        this.$root.$emit( "notify", { message: this.$t( "attrCantBeDisplayed", { id: to.params.id } ), type: "info" } );
        return;
      }

		  //if not a children page - reset internal data
		  if (
		      from.name !== "objectViewGraphView" &&
          to.name != "objectViewGraphView"
      ) {
		    this.dataClear();
      }

		  next();
    },

    methods: {
		  dataClear() {
        this.attrs = null;
        this.data = null;
        this.errors = null;
        this.historyShow = false;
        this.history = null;
        this.historyAttr = null;
        this.derivations = null;
        this.derivationsShow = false;
        this.duplicates = null;

        this.tabActiveId = "tabObject"
      },

		  viewLink( id ) {
        return `/editor/${encodeURIComponent( this.endpoint )}/${encodeURIComponent( this.classId )}/object/${encodeURIComponent( id )}`;
      },

      referenceIs( a ) {
		    return a && a.type === "reference";
      },

		  async dataRq() {
		    const hash = utils.uniqueHashGen();
		    this.$options.hash = hash;

        try {
          let ans = await this.$options.api.post.json(
            "/entities",
            {
              ...this.queryStd,

              id:       this.id,
              endpoint: this.endpoint,
              clientId: this.clientId
            }
          );

          let item = null, attrs = {};

          if ( ans ) {
            if ( ans.errors && ans.errors.length ) throw new Error( ans.errors.join( "<br />" ) );

            if ( ans.item && !utils.objIsEmpty( ans.item ) ) {
              item = ans.item;
              const classes = Object.keys( item.classes );
              if ( !classes ) throw new Error( this.$t( "ObjectClassesNotFound" ) + " \"" + this.id + "\"" );

              ans = await this.$options.api.post.json(
                "/schemas",
                {
                  ...this.queryStd,

                  id:       classes,
                  endpoint: this.endpoint,
                  clientId: this.clientId,
                  lang:     this.langInterf
                }
              );

              if ( ans ) {
                if ( ans.errors && ans.errors.length ) throw new Error( ans.errors.join( "<br />" ) );

                if ( ans.item && !utils.objIsEmpty( ans.item ) ) {
                  for ( const aid in ans.item.attrs ) {
                    if ( ans.item.attrs.hasOwnProperty( aid ) ) {
                      const attr = ans.item.attrs[ aid ];
                      if ( attr.archive == true ) continue;

                      attrs[ attr.id ] = attr;
                    }
                  }

                  if ( this.$options.hash === hash ) {
                    this.attrs = attrs;
                    this.data = item;
                  }
                }
                else {
                  //вместо этого будет показано специальное сообщение
                  //throw new Error( "схема класса(в) \"" + classes.join( ", " ) + "\" не найдена" );
                  this.error = this.$t( "ObjectNoClassesOrProps" );
                }
              }
              else throw new Error( this.$t( "InvalidClassesSchemaAnswer" ) + "\"" + classes.join( ", " ) + "\"" );
            }
            else throw new Error( this.$t( "Object" ) + " \"" + this.id + "\" " + this.$t( "notFound" ) );
          }
          else throw new Error( this.$t( "InvalidObjectRequestAnswer" ) + " \"" + this.id + "\"" );
        }
        catch ( e ) {
          console.error( e );
          this.$root.$emit( "notify", { header: this.$t( "Error" ), message: e.message, type: "error" } );
        }
      },

      async historyRq() {
		    this.history = undefined;

		    const hash = utils.uniqueHashGen();
		    this.$options.historyHash = hash;

        try {
          let ans = await this.$options.api.post.json(
            "/history/entity",
            {
              ...this.queryStd,

              id:       this.id,
              endpoint: this.endpoint,
              clientId: this.clientId,
              lang:     this.langInterf
            }
          );

          if ( ans ) {
            if ( ans.errors && ans.errors.length ) throw new Error( ans.errors.join( "<br />" ) );
            if ( hash === this.$options.historyHash ) {
              for ( const i of ans.items ) {
                  const t = ( new Date( i.date ) ).getTime();
                  i.dateUTC = isNaN( t ) ? 0 : t;
              }
              ans.items.sort( ( a, b ) => b.dateUTC - a.dateUTC );

              this.history = ans.items;
            }
          }
          else throw new Error( this.$t( "InvalidObjectRequestAnswer" ) + " \"" + this.id + "\"" );
        }
        catch ( e ) {
          console.error( e );
          this.$root.$emit( "notify", { header: this.$t( "Error" ), message: e.message, type: "error" } );
          this.history = null;
        }
      },

      async historyAttrRq( id ) {
		    let name = id, type = null;
        if ( id in this.attrs ) {
          const a = this.attrs[ id ];
          if ( a.name ) name = a.name;
          if ( a.type ) type = a.type;
        }

        this.historyAttr = {
          id,
          show: true,
          name,
          type,
          items: null
        };

        if ( !this.history ) await this.historyRq();

        type = "";
        const items = [];
        if ( this.history ) {
          for ( const h of this.history ) {
            const attrs = h.attrs;
            if ( id in attrs ) {
              const a = attrs[ id ];
              if ( !type ) type = a.type;

              const t = {
                ...h,
                values: a.values
              };
              delete t.attrs;

              items.push( t );
            }
          }
        }

        this.$set( this.historyAttr, "items", items );
      },

      valueByAttr( v, id ) {
		    if ( v ) {
		      if ( id && this.attrs && ( id in this.attrs ) ) {
  		      const type = this.attrs[ id ].type ? this.attrs[ id ].type.toLowerCase() : "";
  		      if ( type && type != "reference" ) return fbu.valueBackToFront( v, type, true, this.langInterf );
          }

		      if ( v && v.id ) return v.name ? v.name : v.id;
        }

		    return typeof( v ) == "string" ? v : "";
      },

      valuesContainInferred( v ) {
		    return v.find( i => i.inferred );
      },

      nameOrId( v, addId ) {
		    let n;

		    if ( v ) {
		      if ( v.name ) {
		        n = v.name;
		        if ( addId && v.id ) n += " (" + v.id + ")";
          }
		      else n = v.id;
        }
		    else n = "";

		    return n;
      },

      async derivationsRq() {
		    this.derivations = undefined;

        try {
/*
          let ans = await this.$options.api.post.json(
            "/entities",
            {
              classes: "http://www.w3.org/ns/prov#Derivation",
              filters: {
                "http://www.w3.org/ns/prov#hasEntity": {
                  values: this.id,
                  comparison: "equal"
                }
              },

              endpoint: this.endpoint,
              clientId: this.clientId,
              itemsPerPage: 100
            }
          );
*/
          const itemsAns = {};
          await this.$options.api.allPostJson(
            ( ans, page, itemsPerPage ) => {
              if ( ans.errors && ans.errors.length ) throw new Error( ans.errors.join( "<br />" ) );
              if ( ans && ans.items ) Object.assign( itemsAns, ans.items );
              if ( !ans.items || utils.objIsEmpty( ans.items ) || ans.pages === page ) return true; //finish all requests
            },
            "/entities",
            {
              classes: "http://www.w3.org/ns/prov#Derivation",
              filters: {
                "http://www.w3.org/ns/prov#hasEntity": {
                  values: this.id,
                  comparison: "equal",
                  byName: false
                }
              },

              endpoint: this.endpoint,
              clientId: this.clientId
            }
          );

          if ( itemsAns ) {
            const derivations = {
              items: itemsAns,
              itemsByValues: [],
              classesById: {},
              originsById: {}
            };

            //convert each derivation value in separate derivation
            for ( const itemId in derivations.items ) {
              if ( derivations.items.hasOwnProperty( itemId ) ) {
                const item = derivations.items[ itemId ];

                try {
                  const t = item.attrs["http://www.w3.org/ns/prov#wasInfluencedBy"];
                  if ( t && t.values && t.values.length ) {
                    const id = t.values[0].id;
                    if ( !( id in derivations.classesById ) ) {

                      const ans = await this.$options.api.post.json(
                        "/entity",
                        {
                          id,
                          endpoint: this.endpoint,
                          clientId: this.clientId
                        }
                      );

                      if ( ans && ans.item ) {
                        derivations.classesById[ id ] = ans.item.classes;
                        derivations.originsById[ id ] = ( "http://datavera.kz/ekg/hasOrigin" in ans.item.attrs ) && ans.item.attrs["http://datavera.kz/ekg/hasOrigin"].values && ans.item.attrs["http://datavera.kz/ekg/hasOrigin"].values.length ? ans.item.attrs["http://datavera.kz/ekg/hasOrigin"].values[0] : null;
                      }
                    }
                  }
                }
                catch ( e ) {
                }

                const affectedAttrs = item.attrs["http://www.w3.org/ns/prov#affectedProperty"];
                if ( affectedAttrs && affectedAttrs.values && affectedAttrs.values.length ) {
                  for ( const v of affectedAttrs.values ) {
                    derivations.itemsByValues.push(
                      {
                        derivation: item,
                        affectedAttrId: v.id
                      }
                    );
                  }
                }
              }
            }
            this.derivations = derivations;

            this.derivations.itemsByValues.sort(
                ( a, b ) => {
                  a = this.attrs[ a.affectedAttrId ] ? this.attrs[ a.affectedAttrId ].name : "";
                  b = this.attrs[ b.affectedAttrId ] ? this.attrs[ b.affectedAttrId ].name : "";

                  return a.localeCompare( b );
                }
            );
          }
          else throw new Error( this.$t( "InvalidObjectRequestAnswer" ) + " \"" + this.id + "\"" );
        }
        catch ( e ) {
          console.error( e );
          this.$root.$emit( "notify", { header: this.$t( "Error" ), message: e.message, type: "error" } );
          this.derivations = null;
        }
      },

      async duplicatesRq() {
		    this.duplicates = undefined;

		    let duplicates = undefined;

		    if ( "http://www.w3.org/2002/07/owl#sameAs" in this.data.attrs ) {
          try {
            const items = [];
            for ( const o of this.data.attrs["http://www.w3.org/2002/07/owl#sameAs"].values ) {
              items.push(
                {
                  id:   o.id,
                  name: o.name,
                  rq:   this.$options.api.post.json(
                    "/entity",
                    {
                      ...this.queryStd,

                      id:       o.id,
                      endpoint: this.endpoint,
                      clientId: this.clientId
                    }
                  ),
                  ans:  null
                }
              );
            }

            const rqsAs = await Promise.allSettled( items.map( i => i.rq ) );

            for ( let i = 0; i < rqsAs.length; i++ ) {
              const ans = rqsAs[ i ].value;
              items[ i ].ans = ans ? ans : null;
            }

            duplicates = items.map(
              i => {
                let origin = null, originCode = null;
                if ( i.ans && i.ans.item ) {
                  if ( "http://datavera.kz/ekg/hasOrigin" in i.ans.item.attrs ) {
                    const t = i.ans.item.attrs["http://datavera.kz/ekg/hasOrigin"];
                    if ( t.values && t.values.length ) origin = t.values[0];
                  }
                  if ( "http://datavera.kz/ekg/hasOriginCode" in i.ans.item.attrs ) {
                    const t = i.ans.item.attrs["http://datavera.kz/ekg/hasOriginCode"];
                    if ( t && t.values && t.values.length ) originCode = t.values[0].value;
                  }
                }

                return {
                  id:         i.id,
                  name:       i.name,
                  origin,
                  originCode
                };
              }
            );
          }
          catch( e ) {
            console.error( e );
            this.$root.$emit( "notify", { header: this.$t( "Error" ), message: e.message, type: "error" } );
            duplicates = null;
          }
        }
		    else duplicates = null;

        await this.consolidateErrorsRq();

        this.duplicates = duplicates;

        if ( this.duplicates ) {
          for ( const o of this.duplicates ) {
            if ( !o.origin ) console.error( "no origins", JSON.stringify( o ) );
          }

          if ( this.data && ( "http://datavera.kz/ekg/hasReferenceObject" in this.data.attrs ) ) {
            const a = this.data.attrs[ "http://datavera.kz/ekg/hasReferenceObject" ];
            if ( !a.values || !a.values.length || !a.values[0] ) console.error( "wrong structure", this.data, a );
          }
          else console.error( "no data or hasReferenceObject is data", JSON.stringify( this.data ) );
        }
      },

      async consolidate() {
        try {
  		    this.dataClear();
          this.tabActiveId = "tabReference"

          let ans = await this.$options.api.post.json(
            "/references/validate",
            {
              ...this.queryStd,

              id:       this.id,
              endpoint: this.endpoint,
              clientId: this.clientId
            }
          );
          if ( ans ) {
            if ( ans.errors && ans.errors.length ) throw new Error( ans.errors.join( "<br />" ) );
            else this.$root.$emit( "notify", { header: this.$t( "Consolidation" ), message: this.$t( "ConsolidatedSuccessfully" ), type: "info" } );
          }
          else throw new Error( this.$t( "InvalidObjectRequestAnswer" ) + " \"" + this.id + "\"" );
/*
          ans = await this.$options.api.post.json(
            "/entity",
            {
              ...this.queryStd,

              id:       this.id,
              endpoint: this.endpoint,
              clientId: this.clientId
            }
          );

          if ( ans ) {
            if ( ans.errors && ans.errors.length ) throw new Error( ans.errors.join( "<br />" ) );

            if ( ans.item ) {
              this.$delete( this.data.attrs, "http://datavera.kz/ekg/hasReferenceObject" );
              const item = ans.item.attrs && "http://datavera.kz/ekg/hasReferenceObject" in ans.item.attrs ? ans.item.attrs["http://datavera.kz/ekg/hasReferenceObject"]: null;
              this.$set( this.data.attrs, "http://datavera.kz/ekg/hasReferenceObject", item );
            }
          }
          else throw new Error( this.$t( "InvalidObjectRequestAnswer" ) + " \"" + this.id + "\"" );
*/
        }
        catch( e ) {
          console.error( e );
          this.$root.$emit( "notify", { header: this.$t( "Error" ), message: e.message, type: "error" } );
        }

        await this.dataRq();
        await this.duplicatesRq();
      },

      async consolidateErrorsRq() {
        try {
          let ans = await this.$options.api.post.json(
            "/references/errors",
            {
              ...this.queryStd,

              id:       this.id,
              endpoint: this.endpoint,
              clientId: this.clientId
            }
          );

          if ( ans ) {
            if ( ans.errors && ans.errors.length ) throw new Error( ans.errors.join( "<br />" ) );
            this.consolidateErrors = ans.items && ans.items.length ? ans.items : null;
          }
          else throw new Error( this.$t( "InvalidObjectRequestAnswer" ) + " \"" + this.id + "\"" );
        }
        catch( e ) {
          console.error( e );
          this.$root.$emit( "notify", { header: this.$t( "Error" ), message: e.message, type: "error" } );
        }
      },

    async linkedRq() {
		    this.linked = undefined;

        try {
          const data = await this.$options.api.post.json(
            "/linked",
            {
              ...this.queryStd,

              id:         this.id,
              endpointId: this.endpoint,
              clientId:   this.clientId
            }
          );

          this.linked = {
            to: data && !utils.objIsEmpty( data.itemsTo ) ? data.itemsTo : null,
            from: data && !utils.objIsEmpty( data.itemsFrom ) ? data.itemsFrom : null,
          };
        }
        catch( e ) {
          console.error( e );
          this.$root.$emit( "notify", { header: this.$t( "Error" ), message: e.message, type: "error" } );
          this.linked = null;
        }
      },

      attrGetRefs( aid ) {
		    if ( this.attrs && ( aid in this.attrs ) ) {
		      const attr = this.attrs[ aid ];
          if ( attr.type === "reference" ) return Object.keys( attr.refs );
        }

        return [];
      },

      childrenClose() {
        const path = this.$route.path.replace( /(\/object\/[^/]+).*$/, "$1" );
        this.$router.push( path ? path : "/" );
      },

      close() {
        const path = this.$route.path.replace( /\/object\/.*$/, "" );
        this.$router.push( path ? path : "/" );
      },

      refreshAll() {
        this.$emit( "refresh" );
        this.dataRq();
      }
    },

    computed: {
		  name() {
		    if ( this.data && this.data.name ) return this.data.name;

		    return this.id;
      },

      apiQueryStd() {
        return {
          ...this.queryStd,

          endpoint: this.endpoint,
          clientId: this.clientId,

          langInterf: this.langInterf
        };
      },

      itemHash() {
		    return this.endpoint + "_" + this.clientId + "_" + this.id;
      }
    },

    watch: {
		  itemHash: {
		    handler() {
          this.dataRq();
        },
        immediate: true
      },
      attrs: {
		    handler() {
		      if ( this.attrs ) {
		        if ( !( this.$options.type in this.attrs ) ) {
		          this.attrs[ this.$options.aType ] = {
                id:       this.$options.aType,
                name:     "Относится к классу",
                archive:  false,
                type:     "reference",
                refs:     { "http://www.w3.org/2002/07/owl#Class": "Класс" },
                carMin:   1,
                carMax:   null
              }
            }

		        const a = this.attrs[ this.$options.aType ];
		        if ( !a.carMin ) a.carMin = 1;
          }
        },
        immediate: true
      },
    }
/*
    mounted() {
		  setTimeout(
        async () => {

          const subgraph = await this.$options.api.post.json(
            "/subgraph",
            {
              ...this.queryStd,

              id:       this.id,
              endpoint: this.endpoint,
              clientId: this.clientId,
              depth:    1
            }
          );

          console.log( subgraph.ttl );
        },
        7000
      );
    }
/**/
  };
</script>

<style scoped>
.empty {
}

table > tr > td,
table > tbody > tr > td,
table > tr > th,
table > tbody > tr > th {
  vertical-align: top;
  padding: 0.2em;
}

.attrs {
  margin-top: 1em;
  border: solid 1px #808080;
  border-radius: 0.1em;
  width: 100%;
}
.attrs:first-child {
  margin-top: 0;
}

.main > tbody > tr > td:last-child,
.main > tr > td:last-child{
  width: 1em;
}

.attrs > tbody > tr > th,
.attrs > tbody > tr > td,
.attrs > tr > th,
.attrs > tr > td {
  padding: 0 1em;
  border: solid #808080;
  border-width: 0 1px 1px 0;
  text-align: left;
  vertical-align: top;
}
.attrs > tbody > tr > th:last-child,
.attrs > tbody > tr > td:last-child,
.attrs > tr > th:last-child,
.attrs > tr > td:last-child  {
  border-right-width: 0;
}
.attrs > tbody > tr:last-child > th,
.attrs > tbody > tr:last-child > td,
.attrs > tr:last-child > th,
.attrs > tr:last-child > td {
  border-bottom-width: 0;
}

.attrs > tbody > tr > th,
.attrs > tr > th {
  background-color: #F2F6FB;
  color: #4D4D4D;
  font-weight: bold;
}

.attrs > tbody > tr > td,
.attrs > tr > td {
  color: #212121;
}

.history,
.provenance {
  min-height: 64px;
}

.historyAttrRq {
  display: block;
  cursor: pointer;
  fill: #007BC1;
}
.historyAttrRq:hover {
  fill: #0C97E7;
}

.history .items {
}

.history .items th {
  vertical-align: top;
}

.history .attrs th  {
  width: 15%;
}
.history .attrsWrapper .attrs th {
  width: 30%;
}

.history .item .attrs,
.history .item .attrsWrapper {
  margin: 0;
  padding: 0;
  border: 0;
}

.historyAttr {
  margin: 0;
}

.empty {
  white-space: nowrap;
  font-weight: bold;
  margin-top: 1em;
}

.mainTitle {
  color: #808080;
  font-size: 1.2em;
  margin: 0 0 2em 0;
}
.mainTitle span {
  font-weight: bold;
  color: #000000;
}

.violations {
  display: inline-block;
  position: relative;
}

.violations svg {
  cursor: pointer;
  fill: #FB6E19;
  margin-top: -0.2em;
}

.violations > .tip {
  position: absolute;
  top: 1em;
  left: -0.4em;
  min-width: 10em;
}
.violations > .tip::v-deep .violation {
  margin-top: 1em;
}
.violations > .tip::v-deep .violation:first-child {
  margin-top: 0;
}

.inferred {
  font-size: 0.8em;
  color: #808080;
}

/*
.values td,
.values th {
  border: solid #808080;
  border-width: 0 0 1px 0;
}
.values td:last-child {
}
.values tr:last-child th,
.values tr:last-child td {
  border-bottom-width: 0;
}
span.lang,
.values th:nth-child( 1 ) {
  font-size: 0.8em;
  color: #808080;
}
*/

span.lang {
  font-size: 0.8em;
  color: #808080;
  white-space: nowrap;
  padding-left: 0.5em;
}
.values td,
.values td > div {
  border: dotted #000000;
  border-width: 0 0 1px 0;
}
.values:last-child td,
.values td > div:last-child {
  border-bottom-width: 0;
}

.shorten {
  margin-left: 0.5em;
}
.shorten,
.shorten * {
  font: inherit;
  display: inline-block;
  text-decoration: inherit;
  vertical-align: top;
  color: #000000;
}
.shorten span {
  font-size: 0.8em;
  max-width: 10em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #000000;
}

.links {
  color: #000000;
  font-size: 0.8em;
  margin-left: 0.5em;
}
.links:before {
  content: "( классы: ";
}
.links:after {
  content: " )";
}

.linkRightSpace {
  margin-right: 0.5em;
}
.linkRightSpace:last-child {
  margin-right: 0;
}

.graphView {
  margin-top: 2em;
  text-transform: none;
  padding: 0 1em;
}
.graphView .icon {
  margin-right: 0.5em;
}

.graphViewModal::v-deep > .container {
  max-width: none;
  max-height: none;
  width: 95vw;
  height: 95vh;
}

.graphViewModal::v-deep > .container .body {
  max-width: none;
  max-height: none;
  width: 100%;
  height: 100%;
  overflow: visible;
}

.tabs::v-deep .items:first-child {
  width: 100%;
}

.mainWrapper {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.mainWrapper > .mainTitle {
  flex-grow: 0;
  flex-shrink: 1;
}

.mainWrapper > .tabs {
  flex-grow: 1;
  flex-shrink: 1;
}

.referenceObject,
div.duplicates,
table.duplicates > caption {
  font-size: 1.2em;
  font-weight: bold;
  text-align: left;
}
.referenceObject > a {
  font-size: 0.8em;
  font-weight: normal;
}
.duplicates {
  margin: 1em 0;
}
table.duplicates > caption {
  padding-bottom: 0.5em;
}

.field {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.field button {
  border: none;
  padding: 0;
  background: none;
  cursor: pointer;
  line-height: 1em;
  margin: 0.5em;
  font-size: 1.3em;
}

.field .lang {
  margin-right: 1em;
}

.field .link {
  margin: 0 1em;
}

.save {
  margin-top: 1em;
}

/* remove all internal fields tooltip, cause they already have tooltips there */
.field > .DVfield::v-deep .tooltip {
  visibility: hidden;
  opacity: 0;
  position: absolute;
}

.tabs.tabObject .objectEditor::v-deep .save {
  position: fixed;
  bottom: 2em;
  right: 2em;
}
.tabs.tabObject .objectEditor::v-deep .del {
  position: fixed;
  bottom: 2em;
  left: 50%;
  transform: translate( -50%, 0 );
}

.comma:before {
  content: ", ";
  text-decoration: none;
  color: #000000;
  display: inline-block;
  pointer-events: none;
  white-space: pre;
}

.linkedHdr {
  font-weight: bold;
  margin: 2em 0 0.5em 0;
}
.linkedHdr:first-child {
  margin-top: 0;
}
.linkedClass {
  margin-top: 1em;
  font-weight: bold;
}
.linkedClass:first-child {
  margin-top: 0;
}
.linkedClass .linkedClassItems {
  margin-left: 1em;
  font-weight: normal;
}

.back {
  width: 1.5em;
  height: 1.5em;
  margin-right: 0.5em;
  fill: #0081CA;
  cursor: pointer;
}
.back:hover {
  fill: #0C97E7;
}
</style>